import React from 'react';
import { Link } from 'react-router-dom';
import { Region } from '../../types/orderTypes';
import Dropdown from '../dropdown/Dropdown';
import PorterbuddyLogo from './assets/porterbuddy_grey_landscape.svg';
import PorterbuddyLogoMobile from './assets/porterbuddy_logo_logo-only-white.svg';
import CourierNavbarLinksDesktop from './CourierNavbarLinks';
import {
  SideMenuMobileForCourier,
  SideMenuMobileForCourierLimited,
} from './SideMenuMobileForCourier';

function LeftMenuDesktop({
  showRegionSelection,
  availableRegions,
  selectedRegion,
  changeRegionCallback,
}: {
  showRegionSelection: boolean;
  selectedRegion: Region;
  availableRegions: Region[];
  changeRegionCallback: (region: Region) => void;
}): JSX.Element {
  return (
    <div className="desktop-only">
      <span className="navbar__logo">
        <Link to="/my-deliveries">
          <img
            className="navbar__logo-image"
            src={PorterbuddyLogo}
            alt="Porterbuddy logo"
          />
          <img
            className="navbar__logo-image-narrow"
            src={PorterbuddyLogoMobile}
            alt="Porterbuddy logo"
          />
        </Link>
        <div style={{ width: 10 }} />
        <div
          className="desktop-only"
          style={{
            display: 'flex',
            alignItems: 'baseline',
            paddingRight: 15,
            fontWeight: 500,
          }}
        >
          Courier
        </div>
        <div className="navbar__region">
          {showRegionSelection && (
            <div className="navbar__dropdown">
              <Dropdown
                names={Object.values(availableRegions)}
                placeholder={selectedRegion}
                onChange={(region: Region) => {
                  changeRegionCallback(region);
                }}
              />
            </div>
          )}
        </div>
      </span>
    </div>
  );
}

function LeftMenuMobile({
  showRegionSelection,
  availableRegions,
  selectedRegion,
  changeRegionCallback,
}: {
  showRegionSelection: boolean;
  selectedRegion: Region;
  availableRegions: Region[];
  changeRegionCallback: (region: Region) => void;
}): JSX.Element {
  return (
    <div className="mobile-only">
      <span className="navbar__logo">
        <Link to="/my-deliveries">
          <img src={PorterbuddyLogoMobile} alt="Porterbuddy logo" />
        </Link>
        <div style={{ width: 10 }} />
        <span style={{ paddingRight: 10 }}>Courier</span>
        <div className="navbar__region">
          {showRegionSelection && (
            <div className="navbar__dropdown">
              <Dropdown
                names={Object.values(availableRegions)}
                placeholder={selectedRegion}
                onChange={region => {
                  changeRegionCallback(region);
                }}
              />
            </div>
          )}
        </div>
      </span>
    </div>
  );
}
export function CourierNavBar({
  selectedRegion,
  availableRegions,
  changeRegionCallback,
}: {
  selectedRegion: Region;
  availableRegions: Region[];
  changeRegionCallback: (region: Region) => void;
}): JSX.Element {
  const showRegionSelection: boolean = availableRegions.length > 1;
  return (
    <div className="navbar">
      <div className="navbar__container">
        <LeftMenuDesktop
          showRegionSelection={showRegionSelection}
          availableRegions={availableRegions}
          selectedRegion={selectedRegion}
          changeRegionCallback={changeRegionCallback}
        />
        <LeftMenuMobile
          showRegionSelection={showRegionSelection}
          availableRegions={availableRegions}
          selectedRegion={selectedRegion}
          changeRegionCallback={changeRegionCallback}
        />

        <CourierNavbarLinksDesktop />

        {isCourierLimitedRegion(selectedRegion) ? (
          <SideMenuMobileForCourierLimited />
        ) : (
          <SideMenuMobileForCourier />
        )}
      </div>
    </div>
  );
}

export function isCourierLimitedRegion(region: Region): boolean {
  return region !== Region.OSLO;
}
